// Card-only manifest for ContactLink — a contact attached to a host record, surfaced through the section relation
// rather than its own page, hence no operations and no portal `domains`.
import { ActivityEntityName, ContactLink } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<ContactLink> = {
  component: () => import('./presentation/card.contact.link').then(module => module.CardContactLinkComponent),
  resolution: 'snapshot',
  summarize: link => ({ title: link.name ?? 'Contact', line1: link.email, line2: link.mobile ?? link.workPhone ?? link.phone }),
};

export const contactLinkManifest = registerManifest<ContactLink>({ entity: ActivityEntityName.ContactLink, presentation: { card } });
